const VOWELS = 'аиоуэы'

export default function getRuPredlog(word: string, preposition: string) {
  const wordFirstLetter = word[0].toLowerCase()
  const wordSecondLetter = word[1].toLowerCase()
  const prepositionLastLetter = preposition[preposition.length - 1].toLowerCase()

  if (wordFirstLetter === prepositionLastLetter && !VOWELS.includes(wordSecondLetter)) {
    return `${preposition}о`
  }

  return preposition
}
